import { deletedFilters } from "helpers/redux";
import policy from "policies";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/transportColumns";
import Form from "./form";
import List from "./list";
import Show from "./show";

export default class TransportColumns extends Component {
    componentWillUnmount() {
        this.props.clearParams("transportcolumns", deletedFilters());
    }

    render() {
        const { match, location, history, canCreateBooks, roles } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        const canSeeTransportColumns =
            policy("user", { user: { roles } }).isTruckingOrganizationAdmin() ||
            roles.isTruckingOrganizationExtendedViewer;
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Список колон"
                                nofilter
                                source={source}
                            />
                        )}
                    />
                    {canSeeTransportColumns && (
                        <>
                            <Route
                                path={`${rootUrl}/:id`}
                                render={(rest) => (
                                    <Show
                                        {...rest}
                                        transition="left"
                                        title="Транспортная колонна"
                                        back={back}
                                        source={source}
                                    />
                                )}
                            />
                            {canCreateBooks("transportcolumns") && (
                                <Route
                                    path={`${match.path}/new`}
                                    render={() => (
                                        <Form
                                            {...this.props}
                                            title="Создать колонну"
                                            back={back}
                                            submit={source.apply}
                                        />
                                    )}
                                />
                            )}
                        </>
                    )}
                </Switch>
            </div>
        );
    }
}
